import {
  Drawer as ChakraDrawer,
  DrawerProps as ChakraDrawerProps,
  ThemingProps,
} from '@chakra-ui/react';
import React, { useMemo } from 'react';

import { createContext } from '../../utils/contextUtils';
import { OmitChakraProps } from '../../utils/typeUtils';

export interface DrawerProps
  extends OmitChakraProps<ChakraDrawerProps, 'placement' | keyof ThemingProps> {
  placement?: Extract<ChakraDrawerProps['placement'], 'left' | 'right'>;
  isDismissable?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

interface DrawerContext {
  isDismissable: boolean;
}

const [DrawerContextProvider, useDrawerContext] = createContext<DrawerContext>({
  name: 'DrawerContext',
  hookName: 'useDrawerContext',
  providerName: '<Drawer />',
  defaultValue: { isDismissable: true },
});

export { useDrawerContext };

export const Drawer = ({
  placement = 'right',
  isDismissable = true,
  ...props
}: DrawerProps) => {
  const contextValue = useMemo(() => ({ isDismissable }), [isDismissable]);

  return (
    <DrawerContextProvider value={contextValue}>
      <ChakraDrawer {...props} placement={placement} />
    </DrawerContextProvider>
  );
};
